var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[(!_vm.$session.user)?_c('login-component'):(_vm.$session.sopen)?_c('router-view'):_c('div',{staticClass:"pa-4 text--disabled"},[_vm._v("CONNECTING...")]),_c('modal-component')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }